module.exports = __webpack_public_path__ + "img/client-wash_putin_tw.b2da18a1.svg";